import { render, staticRenderFns } from "./BulkOrdersImport.vue?vue&type=template&id=67869280&"
import script from "./BulkOrdersImport.vue?vue&type=script&lang=js&"
export * from "./BulkOrdersImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBreadcrumbs,VCard})
